import { fetchImpulseData, fetchImpulseCoinsList, fetchCompareImpulses } from "@/Groups/Scanner/private/api/impulseData";

const state = () => ({
  impulses: [],
  compareImpulses: [],
  isReady: false,
  isOpened: true,
  isLoading: false,
  idActiveImpulse: null,
});

const actions = {
  async updateImpulseList({ state, commit }, { custom_tag_id, base_coin_id, tag_id, usd, exclude_assets }){
    try{
      let params = {};
      if(base_coin_id) params['base_coin_id'] = base_coin_id;
      if(exclude_assets) params['exclude_assets'] = exclude_assets;
      if(usd) params['usd'] = usd;
      if(custom_tag_id) params['custom_tag_id'];
      if(tag_id) params['tag_id'] = tag_id;
      commit('SET_LOADING_FLAG', true);
      const data = await fetchImpulseData(params);
      commit('SET_READY_FLAG', true);
      commit('SET_DATA', data);
      return data;
    } catch(err){
      console.warn('Ошибка', err)
    } finally{
      commit('SET_LOADING_FLAG', false);
    }
  },

  async loadCoinsList({ state, commit }, params){
    try{
      commit('SET_ACTIVE_IMPULSE_ID', params.impulse_id);
      return await fetchImpulseCoinsList(params);
    } catch(err){
      console.warn('Ошибка', err)
    } finally{
      commit('SET_LOADING_FLAG', false);
    }
  },

  async loadCompare({ commit }, params) {
    try {
      commit('SET_LOADING_FLAG', true);
      const data = await fetchCompareImpulses(params);
      commit('SET_COMPARE_IMPULSES', data);
      return data;
    } catch (err) {
      console.warn('Ошибка при загрузке сравнения импульсов:', err);
    } finally {
      commit('SET_LOADING_FLAG', false);
    }
  },

  async resetCompare({ commit }) {
    commit('SET_COMPARE_IMPULSES', null);
  },

  toggleOpended({ state, commit }){
    const status = (state.isOpened) ? false : true;
    commit('SET_OPENED_LIST_FLAG', status);
  },

  setActiveImpulseId({ commit }, id) {
    commit('SET_ACTIVE_IMPULSE_ID', id);
  },

  resetImpulse({ commit }) {
    commit('SET_DATA', []);
    commit('SET_COMPARE_IMPULSES', []);
    commit('SET_READY_FLAG', false);
    commit('SET_LOADING_FLAG', false);
    commit('SET_OPENED_LIST_FLAG', true);
    commit('SET_ACTIVE_IMPULSE_ID', null);
  },
};

const mutations = {
  SET_DATA(state, data){ state.impulses = data },

  SET_COMPARE_IMPULSES(state, data) { state.compareImpulses = data; },

  SET_READY_FLAG(state, status = true){ state.isReady = status },

  SET_LOADING_FLAG(state, status){ state.isLoading = status },

  SET_OPENED_LIST_FLAG(state, status){ state.isOpened = status },

  SET_ACTIVE_IMPULSE_ID(state, id){ state.idActiveImpulse = id; }
};

const getters = {
  //Получить все импульсы
  allImpulses: (state) => state.impulses,
  //Готовы ли импульсы к отображению
  isImpulseReady: (state) => state.isReady,
  //Идет ли загрузка импульсов
  isImpulseLoading: (state) => state.isLoading,
  //Получить элемент импульса по ID
  getImpulseById: (state) => (id) => state.impulses.find(item => item.id === id) || null,
  //Кол-во импульсов
  impulsesCount: (state) => state.impulses.length,
  //Развернут ли список импульсов
  isOpenedList: (state) => state.isOpened,
  //Получить активный ID импульса
  activeImpulseId: (state) => state.idActiveImpulse,
  //Получить список compare impulse
  getCompareImpulses: (state) => state.compareImpulses,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};